// extracted by mini-css-extract-plugin
module.exports = {"subHeader":"ExplanationText_subHeader__faPHq","explanationText":"ExplanationText_explanationText__20Ch0"};